import { useContext } from 'react';
import { F as FormElementContext } from '../contexts/FormElementContext-pUV2tgYQ.js';

const useFormElementContext = () => {
  const formElementContext = useContext(FormElementContext);
  return formElementContext;
};

export { useFormElementContext as u };
//# sourceMappingURL=useFormElementContext-BW0cBk3k.js.map
